var React = require('react');

function SDCSkipRight18N (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"x":"12.25","y":"2.5","width":"1.5","height":"13","rx":"0.5","fill":"var(--iconFill, #464646)","key":0}),React.createElement("path",{"d":"M3.85611,15.28328,9.96787,9.3827a.5.5,0,0,0,.01242-.707l-.00807-.00817L3.86234,2.62317a.5.5,0,0,0-.7071.00381l0,0-.35149.35541a.5.5,0,0,0,.00385.70705l5.3819,5.32418-5.375,5.19012a.5.5,0,0,0-.0127.70667l.34708.36009a.5.5,0,0,0,.707.013Z","fill":"var(--iconFill, #464646)","key":1})]));
}

SDCSkipRight18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SDCSkipRight18N;

SDCSkipRight18N.default = SDCSkipRight18N;
